import { styled } from 'styled-components';
import useSound from 'use-sound';
import { useEffect, useState } from 'react';

import { Player as PlayerType, PoolParticipant } from '@src/lib/types';
import { colors } from './Row';
import Row from './Row';

import lowTime from '@src/asset/sound/lowTime.wav';

import up from '@src/asset/img/up.png';
import down from '@src/asset/img/down.png';

const ListContainer = styled.div<{ hide: boolean }>`
  position: absolute;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  flex-wrap: nowrap;

  min-width: 27rem;
  max-width: 27rem;

  z-index: 5;
  width: auto;
  top: 0;
  right: 0;

  @media only screen and (max-width: 768px) {
    /* For mobile phones: */
    transition: right 0.33s;
    right: ${(props) => (props.hide ? '-15.5rem' : '0')};
  }

  div {
    // debug border
    // box-sizing: border-box;
    // -moz-box-sizing: border-box;
    // -webkit-box-sizing: border-box;
    // border: 1pt solid blue;
  }

  // debug border
  // box-sizing: border-box;
  // -moz-box-sizing: border-box;
  // -webkit-box-sizing: border-box;
  // border: 1pt solid blue;
`;

const PlayersContainer = styled.div<{ hide: boolean }>`
  margin-top: 0.5rem;
  display: flex;
  flex-grow: 1;
  flex-direction: column;

  overflow-y: hidden;
  overflow-x: hidden;

  @media only screen and (max-width: 768px) {
    /* For mobile phones: */
    transition: all 0.33s;
    opacity: ${(props) => (props.hide ? '0.8' : '1')};
  }
`;

const TurnDirectionIconContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  min-width: 2rem;
  min-height: 2rem;
  flex-grow: 1;
  border: 1pt solid white
  height: 100%;
`;

const TurnDirectionIcon = styled.img`
  margin-top: 0.5rem;
  height: 1.9rem;
  width: 1rem;
`;

type Props = {
  players: PlayerType[] | null;
  playerId: string;
  currentPlayerTurn: number | null;
  playerChoosingColor: string | null;
  currentPlayerTurnExpiresAt: number | null;
  poolPlayers?: PoolParticipant[];
  gameIsReversed?: boolean;
};

export default function PlayerList(props: Props) {
  const [hide, setHide] = useState(true);

  let i = 0;
  const getColor = (): string => {
    if (i >= colors.length - 1) i = 0;
    const color = colors[i++];
    return color;
  };

  const [playLowTime] = useSound(lowTime, { volume: 0.4 });

  // handle fire low time sound
  useEffect(() => {
    if (props.currentPlayerTurnExpiresAt) {
      const fireSoundAt = props.currentPlayerTurnExpiresAt - 5000;
      const now = Date.now();
      if (fireSoundAt > now) {
        const timeout = setTimeout(() => {
          playLowTime();
        }, fireSoundAt - now);
        return () => clearTimeout(timeout);
      }
    }
  }, [props.currentPlayerTurnExpiresAt]);

  const turnDirectionIcon = props.gameIsReversed ? up : down;

  const players = props.players ? props.players : [];

  return (
    <ListContainer hide={hide} onClick={() => setHide(!hide)}>
      <TurnDirectionIconContainer>
        <TurnDirectionIcon src={turnDirectionIcon} />
      </TurnDirectionIconContainer>
      <PlayersContainer hide={hide}>
        {players.map((player, index) => (
          <Row
            key={player.playerId}
            index={index}
            name={player.name}
            avatarUrl={player.avatar}
            currentPlayerTurn={props.currentPlayerTurn}
            numCards={player.number}
            score={player.score}
            color={getColor()}
            playerId={props.playerId}
            rowPlayerId={player.playerId}
            playerChoosingColor={props.playerChoosingColor}
            rowPlayerDisconnected={player.disconnected}
            currentPlayerTurnExpiresAt={props.currentPlayerTurnExpiresAt}
            poolScore={
              props.poolPlayers?.find((p) => p.playerId === player.playerId)
                ?.score
            }
          />
        ))}
      </PlayersContainer>
    </ListContainer>
  );
}
